import React from 'react';
import Box from '@mui/material/Box';
import {Grid, LinearProgress, Paper, Typography} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const spinSx = {
    fontSize: 16,
    animation: 'spin 1.5s linear infinite',
    '@keyframes spin': {from: {transform: 'rotate(0deg)'}, to: {transform: 'rotate(360deg)'}},
};

/**
 * Panneau de progression affiché pendant le chargement paginé des sources.
 * @param {{ sources: Array<{label, value, color}> }} props
 */
export default function LoadingPanel({sources}) {
    const isDone = v => v === -1;
    return (
        <Box sx={{mt: 3, mx: 2}}>
            <Typography variant="subtitle2" color="text.secondary" sx={{mb: 1.5, fontWeight: 'bold'}}>
                Chargement des données en cours…
            </Typography>
            <Grid container spacing={1.5}>
                {sources.map(({label, value, color}) => (
                    <Grid key={label} size={{xs: 12, sm: 6, lg: 4}}>
                        <Paper elevation={0} sx={{
                            px: 2, py: 1.5, borderRadius: 2,
                            border: '1px solid', borderColor: 'divider',
                            display: 'flex', flexDirection: 'column', gap: 0.8,
                        }}>
                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                {isDone(value)
                                    ? <CheckCircleIcon sx={{fontSize: 16, color: 'success.main'}}/>
                                    : <HourglassEmptyIcon sx={{...spinSx, color: 'warning.main'}}/>
                                }
                                <Typography variant="body2" fontWeight="medium">{label}</Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ml: 'auto'}}>
                                    {isDone(value) ? 'terminé' : `lot ${value}`}
                                </Typography>
                            </Box>
                            <LinearProgress
                                variant={isDone(value) ? 'determinate' : 'indeterminate'}
                                value={isDone(value) ? 100 : undefined}
                                sx={{
                                    borderRadius: 4, height: 5,
                                    bgcolor: `${color}22`,
                                    '& .MuiLinearProgress-bar': {bgcolor: color},
                                }}
                            />
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

